import { put, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    RESET_DOCUMENT_UPLOAD,
    SET_DOCUMENT_UPLOAD,
    UPDATE_STUDENT,
    SET_APPLICATION_DETAIL_POST_DATA,
} from 'store/key';
import { produce } from 'utility/general';
import { checkSiteInfoStudent, checkStudyInfoDocumentUploadValid } from 'utility/formValidate';

const getInitialState = () => ({
    researchProtocolRows: [],
    insuranceCertificateRows: [],
    informedConsentRows: [],
    brochureRows: [],
    writtenRows: [],
    questionnairesRows: [],
    declarationRows: [],
    indemnityAgreementRows: [],
    otherDocumentsRows: [],
    supportingDocumentRows: [],
    decisionDocumentRows: [],
    otherFundingSourceRows: [],
    signedApplicationFormRows: [],

    /** will set data when student check/unCehck */
    suDocDeleteRequestIds: [],
    handledSuDocDeleteRequest: [],
});

function* updateStudent(action) {
    const { documentUpload, applicationDetailPostData, applicationDetail } = yield select();

    if (action.payload === undefined) return;    
    const {
        formId,
        isAmendment,
        student,
    } = action.payload;
    applicationDetailPostData.applicationFormId = formId;
    const postData = applicationDetailPostData.postData;

    // check all site's student is true/false
    const siteInfoList = applicationDetail[formId].siteInfo ?? [];
    const postDataSiteInfo = postData.siteInfo ?? [];
    let isStudent = student ? true : checkSiteInfoStudent(siteInfoList, postDataSiteInfo);
    if (isStudent === undefined) return;

    /** un-save data */
    const postUploadDocuments = postData?.uploadDocuments ?? [];
    const postSuDocRows = postUploadDocuments?.filter(item => item.type === 7) ?? [];
    const postSuDocIds = postSuDocRows?.map(item => item.id) ?? [];

    /** records in db */
    const uploadDocumentsInDb = applicationDetail[formId].uploadDocuments ?? [];
    const suDocDeleteRequestIds = uploadDocumentsInDb?.filter(item => item.type === 7 && !documentUpload.handledSuDocDeleteRequest.includes(item.id))?.map(item => item.id) ?? [];

    const currentDeleteRequest = applicationDetailPostData?.deleteRequest?.uploadDocuments ?? [];
    const currentDeleteRequestIds = currentDeleteRequest?.map(item => item.id) ?? [];

    if (isStudent) {
        /** remove records which exist in DB to deleteRequest */
        suDocDeleteRequestIds?.forEach((id) => {
            if (currentDeleteRequestIds.includes(id)) {
                const index = currentDeleteRequest.findIndex(item => item.id === id);
                if (applicationDetailPostData.deleteRequest.uploadDocuments?.length) {
                    applicationDetailPostData.deleteRequest.uploadDocuments.splice(index, 1);
                }
            }
        });
        if (applicationDetailPostData.deleteRequest.uploadDocuments && !applicationDetailPostData.deleteRequest.uploadDocuments.length) {
            delete applicationDetailPostData.deleteRequest.uploadDocuments;
        }

        documentUpload.suDocDeleteRequestIds = [];
    } else {
        /** hidden(delete) data for postData */
        postUploadDocuments?.forEach((item, index) => {
            if (postSuDocIds.includes(item.id)) {
                if (applicationDetailPostData.postData.uploadDocuments?.length) {
                    applicationDetailPostData.postData.uploadDocuments.splice(index, 1);
                }
            }
        });
        if (applicationDetailPostData.postData.uploadDocuments && !applicationDetailPostData.postData.uploadDocuments.length) {
            delete applicationDetailPostData.postData.uploadDocuments;
        }

        /** add records which exist in DB to deleteRequest */
        suDocDeleteRequestIds?.forEach((id) => {
            if (!applicationDetailPostData.deleteRequest.uploadDocuments) {
                applicationDetailPostData.deleteRequest.uploadDocuments = [];
            }
            if (!currentDeleteRequestIds.includes(id)) {
                applicationDetailPostData.deleteRequest.uploadDocuments.push({ id: id });
            }
        });

        documentUpload.suDocDeleteRequestIds = suDocDeleteRequestIds;
    };

    checkStudyInfoDocumentUploadValid({ applicationDetail: applicationDetail[formId], isAmendment, isStudent, formId });

    yield put({
        type: SET_APPLICATION_DETAIL_POST_DATA,
        payload: applicationDetailPostData,
    });

    yield put({
        type: SET_DOCUMENT_UPLOAD,
        payload: documentUpload,
    });
}

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case RESET_DOCUMENT_UPLOAD:
            return getInitialState();
        case SET_DOCUMENT_UPLOAD:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchDocumentUpload() {
    yield takeEvery(UPDATE_STUDENT, safeSaga(updateStudent));
}

export default reducer;
